<div class="custom-input-container">
  @if (label) {
  <label [for]="id" class="input-label">{{ label }}</label>
  }
  <div class="input-wrapper">
    <input [id]="id" [type]="showPassword ? 'text' : 'password'" [placeholder]="placeholder" [value]="value"
      (input)="onInput($event)" (blur)="onTouched()" [disabled]="disabled" class="custom-input-field"
      [class.ng-invalid]="isInvalid" [class.ng-dirty]="control?.dirty" />
    <button type="button" class="toggle-password-btn" (click)="togglePasswordVisibility()">
      <i class="pi" [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
    </button>
  </div>
  @if (isInvalid) {
  <small class="error-text">{{ errorMessage }}</small>
  }
</div>